import * as Types from '../../../../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ProjectUpdateSubscriptionQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ProjectUpdateSubscriptionQuery = { __typename: 'Subscription', projectUpdate: { __typename: 'ProjectUpdatePayload', projectId: string, status: Types.ProjectStatus } };


export const ProjectUpdateSubscriptionQueryDocument = gql`
    subscription ProjectUpdateSubscriptionQuery {
  projectUpdate {
    projectId
    status
  }
}
    `;

/**
 * __useProjectUpdateSubscriptionQuery__
 *
 * To run a query within a React component, call `useProjectUpdateSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectUpdateSubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectUpdateSubscriptionQuery({
 *   variables: {
 *   },
 * });
 */
export function useProjectUpdateSubscriptionQuery(baseOptions?: Apollo.SubscriptionHookOptions<ProjectUpdateSubscriptionQuery, ProjectUpdateSubscriptionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ProjectUpdateSubscriptionQuery, ProjectUpdateSubscriptionQueryVariables>(ProjectUpdateSubscriptionQueryDocument, options);
      }
export type ProjectUpdateSubscriptionQueryHookResult = ReturnType<typeof useProjectUpdateSubscriptionQuery>;